import EuDutyModal from './EuDutyModal';

export default EuDutyModal;
